import App from './VCEBlastApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iVCEBlast', <App />);
